export const ADD_VIDEO_TEMPORARY = 'VIDEO_TEMPORARY';

export const VIDEO_TYPE = {
  LEARNING: 'learning',
  INSTRUCTION: 'instruction',
};
